import React, { useEffect, useState } from 'react';
import { ethers, BigNumber } from 'ethers';
import { Box, Button, Flex, Text, Image, Spacer,
    // Stack, Card, CardBody, Heading, CardFooter,
    Grid, GridItem,
    Center, SimpleGrid , useToast } from '@chakra-ui/react';
import NFT from './NFT.json';
import { HeaderX } from './HeaderX';
import { RoundX } from './RoundX';
import { RoundY } from './RoundY';
import { NumberMintOpen } from './NumberMintOpen';
import './App.css'
import './new.css'
import image1 from './assets/image/coin_01.png';
import image2 from './assets/image/44coin_01.png';

import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useBalance ,useContractReads, usePrepareContractWrite, useContractWrite, useDisconnect, useWaitForTransaction } from 'wagmi';

// import ListGP from './ListGP.json';
// import ListWL from './ListWL.json';

// import aWdjk3j3h from './aWdjk3j3h.json';

const { MerkleTree } = require('merkletreejs');
const keccak256 = require('keccak256');
window.Buffer = window.Buffer || require("buffer").Buffer;

const MainMint = ({ accounts, setAccounts}) => {

    //* START FIRST SETTING ----------------------------------------------- //
    const networkId = 1;
    const NFTAddress = "0x6ad08291e8C5AC1ED00692D65A932d1a50505E4D";
    const collectionSupply = 10000; //แตกต่างจาก collectionSize ตรงที่ ใน CollectionSize เอาไว้จำกัดการ mint ในแต่ระรอบ
    const maxWhitelistCanMint = 2000;
    
    // const mintPriceXXX = 0.0033;

    // const teamSupply = 1;

    const maxPerGoldPass = 10 ;
    const maxPerWhitelist = 10 ;
    const maxPerPublic = 10 ;

    const GoldPassFree = 3 ;
    const WhitelistFree = 1 ;

    //- แก้ ABI ที่ไฟล์ NFT.json
    // แก้ Whitelist Address ด้านล่าง
    //- เอา Root อัพเดตบน SmartContract
    //- แก้ชื่อของ NFT ทั้งโปรเจค
    // แก้ Link ของโปรเจค NFT หน้า HeaderX
    //- แก้ Mint Schedule
    //- แก้ ภาพให้เป็นของโปรเจค NFT
    //- แก้ Chain ในหน้า index.js และ API ของ Alchemy

    // const WhitelistAddressA = ["0x"];   
    // const AllowlistAddressA = ["0x"];

    //* END FIRST SETTING  ----------------------------------------------- //

    const [JsonX, setJsonX] = useState({
        mintPrice : 1,
        publicPrice : 1,
        totalSupply : 0,
        collectionSize : 0,
        maxWhitelistMinted : 0,
    })

    const [mintAmount, setMintAmount] = useState(1);
    // const isConnectedx = Boolean(accounts[0]);
    
    const [errorText, setErrorText] = useState("");
    
    // const [json, setJson] = useState({})

    const [maxPerRound, setMaxPerRound] = useState()

    const [ProofX, setProofX] = useState()
    const [Verify, setVerify] = useState()

    const [maxCanMint, setMaxCanMint] = useState()

    // const [currentMintPrice, setCurrentMintPrice] = useState()

    const [accountBalance, setAccountBalance] = useState()

    const toast = useToast()

    const [RootText, setRootText] = useState("Not Match") ;

    // const whitelistLeft = JsonX.maxWhitelistCanMint - JsonX.totalSupply ;
    // const totalLeft =  JsonX.collectionSize - JsonX.totalSupply ;

    const [isInitial, setisInitial] = useState(false)
    const [GPproof, setGPproof] = useState([])
    const [ZeroxGPCut, setZeroxGPCut] = useState([])

    const [WLproof, setWLproof] = useState([])
    const [ZeroxWLCut, setZeroxWLCut] = useState([])


    //* START RAINBOW KIT ------------------------------------//


    const {address, isConnected, isDisconnected} = useAccount()

    const { disconnect } = useDisconnect()

    const balance = useBalance({
        address: address,
        formatUnits: 'ether',
        onSuccess(data) {
            setAccountBalance(Number(data.formatted))
            // console.log('Balance Success', Number(data.formatted))
        },
    })

    // const GProotRaw = aWdjk3j3h.GP ;
    // const WLrootRaw = aWdjk3j3h.WL ;

    //* START GP MerkleTree --------------------//
    // const GPleaves = ListGP.list

    // const GPleaveNode = GPleaves.map((x) => keccak256(x))
    // const GPtree = new MerkleTree(GPleaveNode, keccak256, { sortPairs: true })

    // const GPleaf = keccak256(address);

    // const GPbuf2hex = x => '0x' + x.toString('hex')

    // const GPproof = GPtree.getProof(GPleaf).map(x => GPbuf2hex(x.data))

    //     //* ตัดเหลือ 0x..Root ----
    //     const GPmerkleTree = new MerkleTree(GPleaveNode, keccak256, { sortPairs: true});
    //     //*  GoldPass List
    //     const GPCut = GPmerkleTree.toString().slice(3,67)
    //     // console.log(' GPCut -->', GPCut.toString());
    //     const ZeroxGPCut = "0x" + GPCut
    //     console.log('GP Root :', ZeroxGPCut.toString());


    const getProof = async () => {
        if(!isInitial) {
        const root_GP = await fetch(`https://lerdlumyong.xyz:3020/api/lisa/goldpass/getroot`, {
            method: "GET",
            headers: {
            Accept: "application/json",
            "Content-type": "application/x-www-form-urlencoded",
            },
        });
        const resultGP = await fetch(`https://lerdlumyong.xyz:3020/api/lisa/goldpass/getproof/${address}`, {
            method: "GET",
            headers: {
            Accept: "application/json",
                "Content-type": "application/x-www-form-urlencoded",
            },
        });

        const root_WL = await fetch(`https://lerdlumyong.xyz:3020/api/lisa/wl/getroot`, {
            method: "GET",
            headers: {
            Accept: "application/json",
            "Content-type": "application/x-www-form-urlencoded",
            },
        });
        const resultWL = await fetch(`https://lerdlumyong.xyz:3020/api/lisa/wl/getproof/${address}`, {
            method: "GET",
            headers: {
            Accept: "application/json",
                "Content-type": "application/x-www-form-urlencoded",
            },
        });
  

        try {
                let dataGP = await resultGP.json();
                // let root_data_GP = await root_GP.json();
                // console.log("RRRRROOOTTT root_data_GP : ",root_data_GP.merkleRoot)
                console.log("RRRRROOOTTT dataGP : ",dataGP.proof)
                setGPproof(dataGP.proof)
                // setZeroxGPCut(root_data_GP.merkleRoot)

            } catch (e) {
                console.log(e)
            }

            try {

                let dataWL = await resultWL.json();
                // let root_data_WL = await root_WL.json();
                // console.log("RRRRROOOTTT root_data_WL : ",root_data_WL.merkleRoot)
                console.log("RRRRROOOTTT dataWL : ",dataWL.proof)
                setWLproof(dataWL.proof)
                // setZeroxWLCut(root_data_WL.merkleRoot)

            } catch (e) {
                console.log(e)
            }

            // ----- --------- --- ---- ---

        setisInitial(true)
        }
    }
    getProof()

    //* END GP MerkleTree --------------------//

    //* START WL MerkleTree --------------------//
    // const WLleaves = ListWL.list

    // const WLleaveNode = WLleaves.map((x) => keccak256(x))
    // const WLtree = new MerkleTree(WLleaveNode, keccak256, { sortPairs: true })

    // const WLleaf = keccak256(address);

    // const WLbuf2hex = x => '0x' + x.toString('hex')

    // const WLproof = WLtree.getProof(WLleaf).map(x => WLbuf2hex(x.data))

    //     //* ตัดเหลือ 0x..Root ----
    //     const WLmerkleTree = new MerkleTree(WLleaveNode, keccak256, { sortPairs: true});
    //     //*  GoldPass List
    //     const WLCut = WLmerkleTree.toString().slice(3,67)
    //     // console.log(' GPCut -->', GPCut.toString());
    //     const ZeroxWLCut = "0x" + WLCut
    //     console.log('WL Root :', ZeroxWLCut.toString());

    //* END WL MerkleTree --------------------//

    const wagmigotchiContract = {
        address: NFTAddress,
        abi: NFT.abi,
    }
      

      const { data, isError, isLoading, isSuccess } = useContractReads({
        contracts: [
          {
            ...wagmigotchiContract,
            functionName: 'wlPrice',

            // * 0
          },
          {
            ...wagmigotchiContract,
            functionName: 'totalSupply',
            
            // 1
          },
          {
            ...wagmigotchiContract,
            functionName: 'GProot',

            // 2 
          },
          {
            ...wagmigotchiContract,
            functionName: 'maxPerWallet',

             //! 3 ซ้ำ
          },
          {
            ...wagmigotchiContract,
            functionName: 'WLroot',

            // 4 
          },
          {
            ...wagmigotchiContract,
            functionName: '_addressDetail',
            args: [address],
            // 5
          },
          {
            ...wagmigotchiContract,
            functionName: 'publicPrice',
            // * 6
          },
          {
            ...wagmigotchiContract,
            functionName: 'maxPerWallet',
            // 7
          },
          {
            ...wagmigotchiContract,
            functionName: 'isValidGP',
            args: [GPproof,address],
            // 8 Demo args
          },
          {
            ...wagmigotchiContract,
            functionName: 'isValidWL',
            args: [WLproof,address],
            // 9 Demo args
          },
        ],
        // allowFailure: false,
        cacheOnBlock: true,
        cacheTime: 100_000,
        // enabled: false,
        watch: true,
        onSuccess(data) {

            //* START ตัดคำ

            const firstAddressA = address.slice(0,6)
            const lastAddressA = address.slice(37,-1)
            
            //* END

            //* Start --> Check GoldPass , WL

            // const ListGP = Boolean(data[8]);
            // const ListWL = Boolean(data[9])


            // console.log("999 isValidGP ::>>><<< ::: ", ListGP)
            // console.log("999 isValidWL ::>>><<< ::: ", ListWL)

            //* END --> Check GoldPass , WL 

            const maxPerWallet = data[7] ;

            // const MintPhaseA = data[3];
            // console.log("MintPhaseA : ", Number(MintPhaseA))

                    //* START MINT PHASE
                    let thisRound ;
                    let myMinted ;
                    let roundCanMint ;

                        roundCanMint = Number(maxPerWallet) ;
                        thisRound = "GoldPass Round";

                        //* -- Start -- MAX CAN MINT Prepare
                        const leftCheck = collectionSupply - Number(data[1]);
                        const maxCanMintX = Number(maxPerPublic) - Number(data[5][5]);

                        myMinted = Number(data[5][5]) ;

                        if(leftCheck < maxCanMintX) {
                            setMaxCanMint(leftCheck)
                        } else {
                            setMaxCanMint(maxCanMintX)
                        }
                        //* -- END -- MAX CAN MINT Prepare

                    //* END MINT PHASE

            //* START SET JSONX
            setJsonX({
                mintPrice : ethers.utils.formatEther(data[0].toString()),
                // wlPrice : ethers.utils.formatEther(data[0].toString()),
                publicPrice : ethers.utils.formatEther(data[6].toString())
                ,totalSupply : Number(data[1])
                // ,numberMinted : Number(data[2])
                // ,mintPhase : parseInt(MintPhaseA)
                ,FAddress : firstAddressA
                ,LAddress : lastAddressA
                ,collectionSize : collectionSupply,
                maxWhitelistCanMint : maxWhitelistCanMint,

                maxPerGoldPass : maxPerGoldPass,
                maxPerWhitelist : maxPerWhitelist,
                maxPerPublic : maxPerPublic,
                // maxPerWhitelist : maxPerWhitelistX,
                // maxPerAllowlist : maxPerAllowlistX,
                // numberMinted : Number(data[4]),
                addressDetailGP : Number(data[5][2]),
                addressDetailWL : Number(data[5][3]),
                addressDetailPB : Number(data[5][4]),
                numberMinted : Number(data[5][5]),
                thisRound : thisRound,
                // ThisRoundIs : ThisRoundIs,
                myMinted : myMinted,
                roundCanMint : roundCanMint,
                // teamSupply : teamSupply,
                // roundOne : Number(data[6]),
                maxPerWallet : Number(data[7]),
                // ListGP : ListGP,
                // ListWL : ListWL,
                GProot : data[2],
                WLroot : data[4],
                // ZeroxGPCut : ZeroxGPCut,
                // ZeroxWLCut : ZeroxWLCut,

            })
        }
    })

    
    // function rootCheck() {
    //     if (JsonX.GProot == ZeroxGPCut && JsonX.WLroot == ZeroxWLCut) {
            // setRootText("Match")
            // console.log("Match")

            // console.log("$$$ ------------------------")
            // console.log("$$$ ---> True")
            // console.log("$$$ Contract GP",JsonX.GProot)
            // console.log("$$$ Internal GP",ZeroxGPCut)
            // console.log("$$$ Contract GP Type",typeof(JsonX.GProot))
            // console.log("$$$ Internal GP Type",typeof(ZeroxGPCut))
            // console.log("$$$ --- --- --- --- --- ---")
            // console.log("$$$ Contract WL",JsonX.WLroot)
            // console.log("$$$ Internal WL",ZeroxWLCut)
            // console.log("$$$ Contract GP Type",typeof(JsonX.WLroot))
            // console.log("$$$ Internal WL Type",typeof(ZeroxWLCut))
            // console.log("$$$ ------------------------")
        // } else {
        //     setRootText("Not Match")
            // console.log("Not Match")

            // console.log("$$$ ------------------------")
            // console.log("$$$ ---> False")
            // console.log("$$$ Contract GP",JsonX.GProot)
            // console.log("$$$ Internal GP",ZeroxGPCut)
            // console.log("$$$ Contract GP Type",typeof(JsonX.GProot))
            // console.log("$$$ Internal GP Type",typeof(ZeroxGPCut))
            // console.log("$$$ --- --- --- --- --- ---")
            // console.log("$$$ Contract WL",JsonX.WLroot)
            // console.log("$$$ Internal WL",ZeroxWLCut)
            // console.log("$$$ Contract GP Type",typeof(JsonX.WLroot))
            // console.log("$$$ Internal WL Type",typeof(ZeroxWLCut))
    //         // console.log("$$$ ------------------------")
    //     }
    // }

    //* START MINT ZONE RAINBOW KIT //-----------

    // console.log("@@@ ~ roundOne : ", JsonX.roundOne)

        //* -- START MINT PRICE CALCULATOR //-0--
        
        function WhatIsPaidAmountGoldPass (mintXAmount) {

            let paidAmount = mintXAmount ;
                            
            if (JsonX.addressDetailGP < GoldPassFree) {

                const freeRight = GoldPassFree - JsonX.addressDetailGP ;
                
                if (mintXAmount <= freeRight) {
                    paidAmount = 0 ;
                } else {
                    paidAmount = mintXAmount - freeRight ;
                }

            } else {
                paidAmount = mintXAmount ;
            }

            return paidAmount ;
        }

        function WhatIsPaidAmountWhitelist (mintXAmount) {

            let paidAmount = mintXAmount ;
            
            if (JsonX.addressDetailWL < WhitelistFree) {
                        
                const freeRight = WhitelistFree - JsonX.addressDetailWL ;
                
                if (mintXAmount <= freeRight) {
                    paidAmount = 0 ;
                } else {
                    paidAmount = mintXAmount - freeRight ;
                }

            } else {
                paidAmount = mintXAmount ;
            }


            return paidAmount ;
        }
        
        function WhatIsPaidAmountPublic (mintXAmount) {

            let paidAmount = mintXAmount ;
            
            return paidAmount ;
        }
        //* -- END MINT PRICE CALCULATOR //-0---

    

    // const NewwMintPrice = JsonX.mintPrice * BigNumber.from(mintAmount)
    // console.log("AAA mint Amount Number : ___>> :", mintAmount)
    // console.log("AAA Mint Amount  : --- >: ", WhatIsPaidAmount(mintAmount))
    // console.log("AAA BIgNumber Mint Amount  : --- >: ", BigNumber.from(WhatIsPaidAmount(mintAmount)))
    // console.log("Single mint Price : --- :> ", JsonX.mintPrice)

    // const NewwMintPrice = JsonX.mintPrice * BigNumber.from(WhatIsPaidAmount(mintAmount))

    // console.log(" XXX -- NewwMintPrice -- XX : " ,NewwMintPrice )

    // const NewestMintPrice = NewwMintPrice.toFixed(4)

    //* ---- Mint Price GoldPass

    const NewwMintPriceGoldPass = JsonX.mintPrice * BigNumber.from(WhatIsPaidAmountGoldPass(mintAmount))
    
    const NewestMintPriceGoldPass = NewwMintPriceGoldPass.toFixed(4)

    //* ---- Mint Price Whitelist

    const NewwMintPriceWhitelist = JsonX.mintPrice * BigNumber.from(WhatIsPaidAmountWhitelist(mintAmount))
    
    const NewestMintPriceWhitelist = NewwMintPriceWhitelist.toFixed(4)

    //* ---- Mint Price Public

    // const NewestMintPricePublic = 1 ;

    const NewwMintPricePublic = JsonX.publicPrice * BigNumber.from(WhatIsPaidAmountPublic(mintAmount))
    
    const NewestMintPricePublic = NewwMintPricePublic.toFixed(4)

    // console.log("NewestMintPrice : ", NewestMintPrice)

    // console.log(" Real Price : ", JsonX.mintPrice * BigNumber.from(mintAmount))
    // console.log(" Discount Price : ", Number(NewestMintPrice))

    // console.log("accountBalance : >>> ", accountBalance)

    // //* START GOLD PASS MINT ZONE RAINBOW KIT //-----------

    const { config:GPmintConfig , error:GPerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'mintGoldpass',
        // args: [BigNumber.from(mintAmount)],
        args: [BigNumber.from(mintAmount),GPproof],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPriceGoldPass).toString()),
        },
    })

    const { data:GPData, isLoading:GPisLoading, isSuccess:GPisSuccess, write:GPWrite } = useContractWrite({
        ...GPmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(GPerror) {
            // console.log('Error', WLerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })

    // //* START WHITELIST MINT ZONE RAINBOW KIT //-----------

    const { config:WLmintConfig , error:WLerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'mintWhiteList',
        // args: [BigNumber.from(mintAmount)],
        args: [BigNumber.from(mintAmount),WLproof],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPriceWhitelist).toString()),
        },
    })

    const { data:WLData, isLoading:WLisLoading, isSuccess:WLisSuccess, write:WLWrite } = useContractWrite({
        ...WLmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(WLerror) {
            // console.log('Error', WLerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })


    // //* START PUBLIC MINT ZONE RAINBOW KIT //-----------

    const { config:PBmintConfig , error:PBerror } = usePrepareContractWrite({
        address: NFTAddress,
        abi: NFT.abi,
        functionName: 'publicMint',
        args: [BigNumber.from(mintAmount)],
        overrides: {
            from: address,
            value: ethers.utils.parseEther((NewestMintPricePublic).toString()),
        },
    })

    const { data:PBData, isLoading:PBisLoading, isSuccess:PBisSuccess, write:PBWrite } = useContractWrite({
        ...PBmintConfig,
        onSuccess(data) {
            // console.log('Success', data)
            toast({
                title: 'Minting',
                status: 'success',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
        onError(PBerror) {
            // console.log('Error', PBerror)
            toast({
                title: 'Mint Fail',
                status: 'error',
                position: 'top-right',
                duration: 9000,
                isClosable: true,
            })
        },
    })

     //* END MINT ZONE RAINBOW KIT //-----------


      //* END RAINBOW KIT ------------------------------------//

    function getErrorText(a) {
        let b = a.split('execution reverted: ');
        if (b.length == 1) {
            setErrorText(b[0])
        } else if (b.length == 2) {
            setErrorText(b[1])
        } else {
            setErrorText(a)
        }
    }

    async function handleMintGoldPass() {
        // try {
            if(accountBalance >= NewestMintPriceGoldPass) {
                GPWrite?.()
            } else {
                
                toast({
                    title: 'ETH amount is not sufficient',
                    description: 'You have ' + accountBalance.toFixed(5) + ' ETH, but require ' + NewwMintPriceGoldPass.toFixed(4) + ' ETH. + Gas Fees',
                    status: 'error',
                    position: 'top-right',
                    duration: 9000,
                    isClosable: true,
                })
                
                console.log("ETH amount is not sufficient")
            }
        // } catch (err) {
        //     console.log("error: ", err.error.data.message)
        //     getErrorText(err.error.data.message)
        // }
    }

    async function handleMintWhitelist() {
        // try {
            if(accountBalance >= NewestMintPriceWhitelist) {
                WLWrite?.()
            } else {
                
                toast({
                    title: 'ETH amount is not sufficient',
                    description: 'You have ' + accountBalance.toFixed(5) + ' ETH, but require ' + NewwMintPriceWhitelist.toFixed(5) + ' ETH. + Gas Fees',
                    status: 'error',
                    position: 'top-right',
                    duration: 9000,
                    isClosable: true,
                })
                
                console.log("ETH amount is not sufficient")
            }
        // } catch (err) {
        //     console.log("error: ", err.error.data.message)
        //     getErrorText(err.error.data.message)
        // }
    }

    async function handleMintPublic() {
        // try {
            if(accountBalance >= NewestMintPricePublic) {
                PBWrite?.()
            } else {

                toast({
                    title: 'ETH amount is not sufficient',
                    description: 'You have ' + accountBalance.toFixed(5) + ' ETH, but require ' + NewwMintPricePublic.toFixed(5) + ' ETH. + Gas Fees',
                    status: 'error',
                    position: 'top-right',
                    duration: 9000,
                    isClosable: true,
                })
                console.log("ETH amount is not sufficient")
            }
        // } catch (err) {
        //     console.log("error: ", err.error.data.message)
        //     getErrorText(err.error.data.message)
        // }
    }

    const handleDecrement = () => {

        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);

    }

    const handleIncrement = () => {

        if (mintAmount >= maxCanMint) return;
        setMintAmount(mintAmount + 1);

    }

    // console.log("222 mintAmount :>>> ", mintAmount)
    // console.log("222 maxCanMint :>>> ", maxCanMint)

    if(WLproof.length > 0 ) {

        console.log("ListWL true : ", WLproof)
    } else {
        console.log("ListWL false : ", WLproof)
    }

    if(GPproof.length > 0 ) {

        console.log("ListGP true : ", GPproof)
    } else {
        console.log("ListGP false : ", GPproof)
    }


    useEffect(() => {
        getProof()
    },[])
    

        return (

            <div>
                <Flex justify="center" align="center" >
                    <Box width="480px">
                        
                        <div
                                className="mintZone1"
                        > 
                            <Grid
                            h='200px'
                            templateRows='repeat(2, 1fr)'
                            templateColumns='repeat(7, 1fr)'
                            gap={4}
                            bg='white'
                            borderRadius="30px"
                            mb="20px"
                            p="10px"
                            >
                                <GridItem rowSpan={2} colSpan={3}
                                // bg='orange'
                                borderRadius='20px'
                                >
                                    <Image
                                            borderRadius='20px'
                                            // boxSize='150px'
                                            // mb="10px"
                                            src={image2}
                                    />
                                </GridItem>
                                <GridItem rowSpan={2} colSpan={4}
                                    // bg='tomato
                                    textAlign="left"
                                >
                                    <Text
                                    marginTop="10px"
                                    fontSize="20px"
                                    textAlign="left"
                                    // letterSpacing="0.8px"
                                    color="black"

                                    >
                                        NovaPepe also opened Mint today.
                                    </Text>
                                    <a href="https://mintpepe.web.app/" target="_blank">
                                    <Button
                                        colorScheme='yellow'
                                        mt="15px"

                                    >
                                        Enter Mint site
                                    </Button>
                                    </a>

                                </GridItem>
                                   
                               

                            </Grid>

                        {isConnected ? (
                            <>
                                <Text
                                    textAlign="right"
                                >
                                    R-TEST : {RootText}
                                </Text>

                                <Text
                                    textAlign="right"
                                >
                                    Version : L14.10.5
                                </Text>
                                <div
                                    className="mintZone"
                                >
                                    <Box
                                        marginBottom="20px"
                                        align="right"
                                    >
                                        <Button
                                            colorScheme='yellow'
                                            onClick={() => disconnect()}
                                        >
                                        Logout
                                        </Button>
                                    </Box>
                                    <center>
                                        <Image
                                            borderRadius='20px'
                                            boxSize='150px'
                                            src={image1}
                                        />
                                    </center>

                                    <Text
                                        marginTop="10px"
                                        fontSize="23px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >Total Minted : {JsonX.totalSupply} / {JsonX.collectionSize}</Text>
                                
                                    <Text
                                        marginTop="10px"
                                        fontSize="23px"
                                        letterSpacing="0.8px"
                                        color="black"
                                    >You minted : {JsonX.myMinted} / {JsonX.roundCanMint}</Text>

                                    <NumberMintOpen
                                        HandleDecrement = {handleDecrement}
                                        HandleIncrement = {handleIncrement}
                                        MintAmount = {mintAmount}
                                        // HandleMint = {handleMint}
                                        JsonX = {JsonX}
                                        Verify = {Verify}
                                        WLWrite = {WLWrite}
                                        networkId = {networkId}
                                        accountBalance = {accountBalance}
                                        handleMintPublic = {handleMintPublic}
                                        handleMintWhitelist = {handleMintWhitelist}
                                        handleMintGoldPass = {handleMintGoldPass}

                                        NewestMintPricePublic = {NewestMintPricePublic}
                                        NewestMintPriceWhitelist = {NewestMintPriceWhitelist}
                                        NewestMintPriceGoldPass = {NewestMintPriceGoldPass}
                                        WLproofX = {WLproof} 
                                        GPproofX = {GPproof}
                                    />

                                    <Text
                                        marginTop="10px"
                                        fontSize="13px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >(Your address : {JsonX.FAddress}...{JsonX.LAddress})</Text>


                                    <Text
                                        marginTop="20px"
                                        mb="25px"
                                        fontSize="25px"
                                        letterSpacing="0.8px"
                                        
                                        color="black"
                                    >{errorText}</Text>

                                </div>

                                <HeaderX 

                                />
                                
                                <RoundY 
                                    JsonX = {JsonX}
                                />

                            </>
                            ) : (
                                <>
                                <div className="loginZone"> 
                                    
                                    <center>
                                        <Image
                                            borderRadius='20px'
                                            boxSize='150px'
                                            mb="10px"
                                            src={image1}
                                        />
                                    </center>

                                    <Text
                                        fontSize="28px"
                                        padding="5px 0px"
                                        color="black"
                                        mb="30px"
                                        
                                    >
                                        Connect wallet <br/> to mint LISA NFT.
                                    </Text>   

                                    <Box>
                                        <Flex>
                                            <Spacer/>
                                            <Box
                                                // w='146px'
                                                // bg='red.500'
                                            >
                                                <ConnectButton/> 
                                            </Box>
                                            <Spacer/>
                                        </Flex>
                                    </Box>

                                    {/* <Box
                                        className="MintBTN"
                                    >
                                        <ConnectButton/>   
                                    </Box> */}
                                    
                                    <Text
                                        marginTop="20px"
                                        fontSize="25px"
                                        color="black"
                                    >{errorText}</Text>
                                
                                </div>

                                <HeaderX />

                                <RoundY
                                    JsonX = {JsonX}
                                />
                            </>
                            
                            )}
                    
                    </div>

                    </Box>
                    
                    
                </Flex>
            </div>
        );
};

export default MainMint;